export default class ResultController {
  /* @ngInject */
  constructor(DictionaryService, $log, $state, ConfigurationService, ProductLinkService) {
    this.$log = $log;
    this.DictionaryService = DictionaryService;
    this.isProductLink = ProductLinkService.getProductLinkVerification();
    this.$state = $state;
    this.authorable = ConfigurationService.getConfiguration();
  }

  $onInit() {
    this.concatenateSolutions();
    this.filteredSolutions = this.filterSolutions();
    this.filteredStates = this.filterStates();
  }

  $onChanges() {
    this.concatenateSolutions();
    this.filteredSolutions = this.filterSolutions();
    this.filteredStates = this.filterStates();
  }

  concatenateSolutions() {
    this.allSolutions = this.expert.expertPrimarySolutions
      .concat(this.expert.expertSecondarySolutions);
  }

  filterSolutions() {
    return this.allSolutions
      .filter(solution => this.selectedSolutions[solution.key]);
  }

  filterStates() {
    return this.expert.stateCoverage.length === 8 ? 'National' : this.expert.stateCoverage
      .join(', ');
  }

  expertTypeLookup(type) {
    return this.DictionaryService.expertTypeLookup(type);
  }

  solutionLookup(solution) {
    return this.DictionaryService.solutionDictionaryLookup(solution, 'name');
  }

  goToExpert() {
    this.$state
      .go('root.expert', { expertID: this.expert.id, isProductLink: this.isProductLink });
  }
}



// WEBPACK FOOTER //
// ./src/components/result/result.controller.js